"use client";
import { jsx } from "react/jsx-runtime";
import { Popper, PopperContent } from "../Popper/index.js";
import { FilterFooter, FilterHeader, FilterTabs } from "./components/index.js";
import { SelectorGenerator } from "./selector-generator.js";
import * as __rspack_external_react from "react";
const FiltersDropdown = /*#__PURE__*/ __rspack_external_react.forwardRef(({ optionsSelector = [] }, _ref)=>/*#__PURE__*/ jsx(SelectorGenerator, {
        optionsSelector: optionsSelector
    }));
FiltersDropdown.displayName = 'FiltersDropdown';
const FiltersWrapper = /*#__PURE__*/ __rspack_external_react.forwardRef(({ children }, _ref)=>/*#__PURE__*/ jsx(PopperContent, {
        removePadding: true,
        align: "end",
        side: "bottom",
        removePortal: true,
        children: children
    }));
FiltersWrapper.displayName = 'FiltersWrapper';
const FiltersTabs = /*#__PURE__*/ __rspack_external_react.forwardRef(({}, _ref)=>/*#__PURE__*/ jsx(FilterTabs, {}));
FiltersTabs.displayName = 'FiltersTabs';
const FiltersHeader = /*#__PURE__*/ __rspack_external_react.forwardRef(({ onSearch, setFocusEvent, sortItems }, _ref)=>/*#__PURE__*/ jsx(FilterHeader, {
        onSearch: onSearch,
        setFocusEvent: setFocusEvent,
        sortItems: sortItems
    }));
FiltersHeader.displayName = 'FiltersHeader';
const FiltersContent = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx("div", {
        ref: ref,
        className: className,
        ...props,
        children: props.children
    }));
FiltersContent.displayName = 'FiltersContent';
const FiltersFooter = /*#__PURE__*/ __rspack_external_react.forwardRef(({}, _ref)=>/*#__PURE__*/ jsx(FilterFooter, {}));
FiltersFooter.displayName = 'FiltersFooter';
const Filters = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ jsx("div", {
        ref: ref,
        className: className,
        ...props,
        children: /*#__PURE__*/ jsx(Popper, {
            open: true,
            children: children
        })
    }));
Filters.displayName = 'Filters';
export { Filters, FiltersContent, FiltersDropdown, FiltersFooter, FiltersHeader, FiltersTabs, FiltersWrapper };
